import React from "react";

interface MediaDaySectionHeaderProps {
  label: string;
  count: number;
  collapsed: boolean;
  onToggle: () => void;
}

const MediaDaySectionHeader: React.FC<MediaDaySectionHeaderProps> = ({ label, count, collapsed, onToggle }) => {
  return (
    <button
      type="button"
      data-section="media-day-section-header"
      onClick={onToggle}
      aria-expanded={!collapsed}
      aria-label={`${collapsed ? "Expand" : "Collapse"} ${label}`}
      className="group/day flex w-full min-h-11 items-center gap-2 rounded-lg py-0.5 pl-0.5 pr-0 text-left transition-colors duration-200 hover:bg-white/5 focus:outline-none focus-visible:ring-2 focus-visible:ring-[var(--focus-ring)]"
    >
      <span className="h-4 w-0.5 flex-shrink-0 rounded-full bg-[rgb(var(--primary-green-rgb))]" aria-hidden="true" />
      <span className="min-w-0 flex-1 truncate text-[15px] font-semibold tracking-wide text-[var(--text-1)]">
        {label}
      </span>
      <span className="tabular-nums text-xs font-medium text-[var(--text-3)]">{count}</span>
      <span
        className="flex h-11 w-11 flex-shrink-0 items-center justify-center text-[var(--text-3)] transition-colors duration-200 group-hover/day:text-[var(--text-1)]"
        aria-hidden="true"
      >
        <svg
          className={`h-5 w-5 transition-transform duration-200 ${collapsed ? "-rotate-90" : "rotate-0"}`}
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.2} d="M6 9l6 6 6-6" />
        </svg>
      </span>
    </button>
  );
};

export default MediaDaySectionHeader;
